export default __webpack_public_path__ + "static/media/arena_18.9f1b36de.jpeg";